import { createSlice } from '@reduxjs/toolkit';

const initState = {
    restrictScreen: false
};

export const RestrictScreenSlice = createSlice({
    name: 'RestrictScreen',
    initialState: initState,
    reducers: {
        setRestrictScreen: (state, action) => {
            let tempObj = { ...state, ...action.payload };
            return tempObj;
        },
        resetRestrictScreen: () => initState
    }
});

export const { setRestrictScreen, resetRestrictScreen } = RestrictScreenSlice.actions;

export default RestrictScreenSlice.reducer;
